import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { LoadingSpinner, Dropdown } from 'yankees-react-utils';
import dayjs from 'dayjs';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import GameLogGame from './GameLogGame';
import { useOktaQuery, Game } from '../data';

const StyledHeader = styled.h4`
    @media (min-width: 992px) {
        position: sticky;
        top: 0;
    }
`;

const queryGames = async (accessToken, playerId, yearId) => {
    const resp = await Game.byplayerstats(accessToken, { playerId, yearId });
    return resp.games.sort((a, b) => (dayjs(a.gamedate).isBefore(b.gamedate) ? 1 : -1));
};

const GameLogs = ({ playerId, isPitcher, isCatcher, header, gameWrapper, getStatLines }) => {
    const { t: translate } = useTranslation();
    const LogsYear = new Date().getFullYear();
    const [year, setYear] = useState({ name: LogsYear, value: LogsYear });
    const { data: games, status, refetch } = useOktaQuery(
        ['gamesbyplayerstats', { playerId, includePrevious: true, yearId: year.value }],
        (accessToken) => queryGames(accessToken, playerId, year.value),
    );
    const yearOptions = [LogsYear, LogsYear - 1, LogsYear - 2, LogsYear - 3, LogsYear - 4,
        LogsYear - 5, LogsYear - 6, LogsYear - 7, LogsYear - 8, LogsYear - 9, LogsYear - 10].map((y) => ({ name: y, value: y }));

    useEffect(() => {
        refetch();
    }, [year, refetch]);
    if (status === 'loading') {
        return (
            <div className="d-flex py-5 justify-content-center">
                <LoadingSpinner />
            </div>
        );
    }

    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-1">
                {header || (
                    <StyledHeader className="mb-0">
                        {translate('home.game-logs')}
                    </StyledHeader>
                )}

                <Dropdown options={yearOptions} value={year} onSelect={setYear} />
            </div>
            {games?.length
                ? (
                    <div className="border rounded overflow-hidden">
                        {games.map((game) => (
                            <GameLogGame
                                game={game}
                                isPitcher={isPitcher}
                                isCatcher={isCatcher}
                                playerId={playerId}
                                key={game.gameid}
                                wrapper={gameWrapper}
                                getStatLines={getStatLines}
                            />
                        ))}
                    </div>
                )
                : <div className="d-flex justify-content-center py-2">{translate('home.no-games')}</div>}
        </>
    );
};

GameLogs.propTypes = {
    playerId: PropTypes.number.isRequired,
    isPitcher: PropTypes.bool,
    isCatcher: PropTypes.bool,
    header: PropTypes.element,
    gameWrapper: PropTypes.func,
    getStatLines: PropTypes.func,
};

GameLogs.defaultProps = {
    isPitcher: false,
    isCatcher: false,
    header: undefined,
    gameWrapper: undefined,
    getStatLines: undefined,
};

export default GameLogs;
